import {Component, OnInit, ViewChild} from '@angular/core';
import {Chunker} from '../framework/chunker';
import {FrameworkHttpService} from '../framework/http/service';


import {Injectable} from '@angular/core';
import {QARService, ReportEntity, SORUserEntity} from '../services/qar.service';
import {Observable, of} from 'rxjs';
import {debounceTime, map, startWith, switchMap} from 'rxjs/operators';
import {FormControl} from '@angular/forms';
import {UITableComponent} from '../framework/ui/table';


@Component({
	selector: 'app-page-reassign-reports',
	templateUrl: './reassign-reports.html',
	providers: [QARService]
})
export class ReassignReportsComponent implements OnInit {

	@ViewChild('table', {static: false}) table: UITableComponent;

	constructor(public api: QARService) {
	}

	ngOnInit(): void {
		this.reassign_init();

		this.reassign.autocomplete$ = this.reassign.sorUserIdFormControl.valueChanges.pipe(
			startWith(''),
			// delay emits
			debounceTime(300),
			// use switch map so as to cancel previous subscribed events, before creating new once
			switchMap(value => {
				//if (value !== '') {
				return this.aliases_lookup(value);
				/*} else {
					// if no value is present, return null
					return of(null);
				}*/
			}));
	}

	public reassign = {
		reassigning: {},
		sorUserIdFormControl: new FormControl(),
		autocomplete$: null,
		loading: false,
		data: [],
		chunker: new Chunker([]),
		chunkedData: [],
		noOpenReport: false,
		report: new ReportEntity(),
		checked: {},
		tableOptions: {
			refreshButton: true,
			onRefreshContext: this,
			onRefreshFunction: () => {
				this.reassign_init();
			}
		},
		tableHeaders: [
			{id: '', label: ''},
			{idFunction: this.idFunctionApproverFirstNameOriginal, label: 'Original Approver First Name', filterable: true},
			{idFunction: this.idFunctionApproverLastNameOriginal, label: 'Original Approver Last Name', filterable: true},
			{idFunction: this.idFunctionApproverFirstName, label: 'Approver First Name', filterable: true},
			{idFunction: this.idFunctionApproverLastName, label: 'Approver Last Name', filterable: true},
			{
				id: 'StatusId',
				label: 'Status',
				filterable: true,
				type: 'dropdown',
				options: {noEmptyChoice: false, choices: {pending: 'Pending', '': 'All'}, emptyChoiceText: '(Status)'}
			},
			{id: '', label: 'Action'}
		],
		modalConfirm: {
			display: false,
			title: '',
			text: '',
			cb: (yesorno) => {
			}
		},
		modalAlert: {
			display: false,
			title: '',
			text: '', cb: (yesorno) => {
			}
		},
	};

	public confirm(text, title, cb) {
		this.reassign.modalConfirm.display = true;
		this.reassign.modalConfirm.text = text;
		this.reassign.modalConfirm.title = title;
		this.reassign.modalConfirm.cb = (yesorno) => {
			this.reassign.modalConfirm.display = false;
			cb(yesorno);
		};
	}

	public alert(text, title = 'Alert') {
		this.reassign.modalAlert.display = true;
		this.reassign.modalAlert.title = title;
		this.reassign.modalAlert.text = text;
		this.reassign.modalAlert.cb = (yesorno) => {
			this.reassign.modalAlert.display = false;
		};
	}

	public reassign_unassign(d) {
		this.confirm('Are you sure you want to unassign this person?', 'Warning', (yes) => {
			if (yes) {
				this.reassign.reassigning[d.Id] = true;
				this.api.unassignReportApprovers(d.Id).then(r => {
					this.reassign_init();
					this.reassign.reassigning[d.Id] = false;
				});
			}
		});
	}

	public reassign_doReassign() {
		const checked = [];
		for (const c in this.reassign.checked) {
			if (this.reassign.checked[c]) {
				checked.push(c);
				for (const l of this.reassign.data) {
					if (parseInt(l['Id'], 0) === parseInt(c, 0)) {
						console.log('l', l['SORUserApproverId'], this.reassign.sorUserIdFormControl.value.Id);
						if (parseInt(l['SORUserApproverId'], 0) === parseInt(this.reassign.sorUserIdFormControl.value.Id, 0)) {
							this.alert('You cannot reassign the original approver to his own report', 'Warning');
							return;
						}
					}
				}
			}
		}
		if (!checked.length) {
			alert('Please select at least one line of the report');
		} else {
			const newUser = this.reassign.sorUserIdFormControl.value;
			if (!newUser) {
				alert('Please select a user');
			} else {

				// check that you are not having the same user


				this.api.reassignReportApprovers(newUser.Id, checked).then(r => {
					this.reassign_init();
				});
			}
		}
	}


	public aliases_lookup(value: string): Observable<SORUserEntity[]> {
		if (typeof value === 'string') {
			return this.api.searchSORUser(value).pipe(
				// map the item property of the github results as our return object
				map(results => results)
			);
		} else {
			return new Observable<SORUserEntity[]>();
		}
	}

	autocompleteDisplayUser(w: SORUserEntity) {
		if (!w) {
			return '';
		}
		return w.FirstName + ' ' + w.LastName + ' ( ' + w.Login + ' )';
	}


	idFunctionApproverFirstNameOriginal(d) {
		return d.SORUserApprover.FirstName;
	}

	idFunctionApproverLastNameOriginal(d) {
		return d.SORUserApprover.LastName;
	}

	idFunctionApproverFirstName(d) {
		if (d.SORUserOverridenApprover) {
			return d.SORUserOverridenApprover.FirstName;
		}
		return '';
	}

	idFunctionApproverLastName(d) {
		if (d.SORUserOverridenApprover) {
			return d.SORUserOverridenApprover.LastName;
		}
		return '';
	}

	public reassign_init() {
		this.reassign.checked = {};
		this.reassign.sorUserIdFormControl.setValue(null);
		this.api.retrieveCurrentQARReport(() => {
			this.reassign.noOpenReport = true;
		}).then(report => {
			this.reassign.report = report;
			if (report.StatusId === 'open') {
				this.api.retrieveQARReportsBrowserRows('latest').then(r => {
					this.reassign.chunkedData = r;
					this.reassign.tableHeaders[5]['filterValue'] = 'pending';
					this.table.sorting = {by: this.reassign.tableHeaders[5], direction: 'asc'};
					this.reassign.chunker = new Chunker(r);
					this.reassign.data = r;
				}, e => {
					if (e.status === 409) {
						this.reassign.noOpenReport = true;
					} else {
						alert('Sorry, something went wrong, please refresh the page to try again');
					}
				});
			} else {
				this.reassign.noOpenReport = true;
			}
		}, e => {
			console.error(e);
			if (e.status === 409) {
				this.reassign.noOpenReport = true;
			} else {
				alert('Sorry, something went wrong, please refresh the page to try again');
			}
		}).catch(e => {
			console.error(e);
			if (e.status === 409) {
				this.reassign.noOpenReport = true;
			} else {
				alert('Sorry, something went wrong, please refresh the page to try again');
			}
		});
	}

	public reassign_hasSelection() {
		const checked = [];
		for (const c in this.reassign.checked) {
			if (this.reassign.checked[c]) {
				checked.push(c);
			}
		}
		return checked.length > 0;
	}
}
